var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardGold({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: ".9vw",
    height: ".9vw",
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.90746 7.63743L4.90698 7.6369L4.90459 7.63529L4.90746 7.63743ZM14 5.95455L12.9449 2.83209L9.10975 0.5L1.1622 5.2385L0 8.71176L4.68515 11.5L4.76212 7.72086L1.11727 5.39305L1.42993 5.57807L1.2516 5.4631L1.8884 5.84171L1.30897 5.4631L4.90698 7.6369L12.6542 3.15775L11.4141 3.91925L12.866 3.08984L9.99228 4.79198L5.00403 7.85454L4.68467 11.4995L13.9995 5.95348L14 5.95455ZM5.06235 6.54706L2.96408 5.29465L5.00499 6.00053L11.2534 2.89893L5.06235 6.54706Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardGold);
export default __webpack_public_path__ + "static/media/card_gold.eef70140d476c2dc309c371e60394c9d.svg";
export { ForwardRef as ReactComponent };